'use client';
import styled from 'styled-components';

export const StyledSectionIntro = styled.div`
  margin: 0 auto;
  max-width: ${props => props.maxWidth || 870}px;
  padding: ${props => props.theme.spacing(0, 5)};
  text-align: center;
  width: 100%;
  color: ${props =>
    props.$fontColor && props.theme.colors.get(props.$fontColor)};
`;

export const Header = styled.h2`
  ${props => props.theme.typography[props.$typography]}
  width: 100%;
  margin-bottom: 0.5em;
  min-height: calc(
    ${props => props.theme.typography[props.$typography]['font-size']} *
      ${props => props.theme.typography[props.$typography]['line-height']}
  );
`;

export const Subheader = styled.div`
  ${props => props.theme.typography.heading5}
  min-height: calc(
    ${props => props.theme.typography.heading5['font-size']} *
    ${props => props.theme.typography.heading5['line-height']}
  );
  width: 100%;
  span {
    display: inline-block;
    max-width: 80%;
    @media ${props => props.theme.tabletS} {
      max-width: 100%;
    }
  }
`;
